<div class="row mt-2 no-gutters">
  <div class="col">
    <small *ngIf="accountCategory== 'RENTAL_FLEET'"><a [routerLink]="['/rental-fleet']" class="text-secondary">Admin
        Console</a>
      /<a [routerLink]="['/admin-roles']" class="text-secondary" (click)="showSearchResult = false; getAllUsers()"> User Roles</a></small>
    <small *ngIf="accountCategory== 'FLEET_MANAGEMENT_COMPANY' || accountCategory == 'MOBILITY_COMPANY' || accountCategory == 'FIELD_SERVICE_COMPANY'"><a [routerLink]="['/commercial-fleet']"
        class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/admin-roles']" class="text-secondary" (click)="showSearchResult = false; getAllUsers()"> User Roles</a></small>
    <small *ngIf="accountType == 'VEHICLE_SERVICE_PROVIDER'"><a [routerLink]="['/service-provider/dashboard']"
        class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/admin-roles']" class="text-secondary" (click)="showSearchResult = false; getAllUsers()"> User Roles</a></small>
    <small *ngIf="accountCategory== 'DEALER'"><a [routerLink]="['/dealer']"
        class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/admin-roles']" class="text-secondary" (click)="showSearchResult = false; getAllUsers()"> User Roles</a></small>
    <small *ngIf="accountCategory== 'CORPORATE' || accountCategory == 'FINANCING_GROUP'"><a [routerLink]="['/corporate']"
        class="text-secondary">Admin Console</a>
      /<a [routerLink]="['/admin-roles']" class="text-secondary" (click)="showSearchResult = false; getAllUsers()"> User Roles</a></small>
    <small *ngIf="showSearchResult">
      <a class="text-secondary pointer" (click)="searchResult.onNavSearchClick()"> / Search</a>
    </small>
  </div>
</div>

<div *ngIf="showSearchResult" class="row mt-2 no-gutters">
  <div class="col-12">
    <app-search-results [userList]="searchedUserList" (selectedItemEmitter)="onSearchItemDetail($event);"
      (selectedItemCloseEmitter)="selectedSearchItemForView=null;" #searchResult></app-search-results>
  </div>
</div>

<!-- <div class="row pl-3 pr-3 pb-3 pt-2"> -->
<div *ngIf="!showSearchResult" class="row pt-2 no-gutters">
  <div class="col-sm-12"><button type="button" class="btn btn-primary float-right" data-toggle="modal"
      data-target="#addAdmin" data-backdrop="static" data-keyboard="false">Add User
      <!-- &nbsp;<span><i class="fas fa-chevron-right"></i></span> -->
    </button></div>
  <div class="table-responsive col-sm-12 mt-3 pb-3">
    <table class="table table-striped tbl-scrollable">
      <thead class="thead-light">
        <tr>
          <th scope="col" width="10%" class="text-center"><button class="btn btn-outline-danger py-0 delete-button"
              [disabled]="selectedAdmins.length < 1" data-toggle="modal" data-target="#deleteAdmin"><i
                class="fa fa-trash"></i></button>
          </th>
          <th scope="col" width="12%" class=""></th>
          <th scope="col" width="16%" class="d-table-cell d-sm-none">Name</th>
          <th scope="col" class="d-none d-sm-table-cell">Name</th>
          <th scope="col" width="21%" class="d-none d-sm-table-cell">Email</th>
          <th scope="col" width="16%" class="d-none d-sm-table-cell">Phone</th>

          <!-- <th scope="col" class="pr-0">Status</th> -->
          <th scope="col" width="13%">Role</th>
          <th scope="col" width="12%" class="d-none d-sm-table-cell">Last Sign-In</th>
        </tr>
      </thead>
      <tbody class="max-height-57">
        <tr *ngFor="let admin of admins; let i = index">
          <th width="10%" scope="row" class="text-center pr-0">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" name="checkbox" class="custom-control-input" [disabled]="admin.id == loggedInUserId"
                id="admin_{{i}}" (change)="onAdminSelected(admin.id)">
              <label class="custom-control-label" for="admin_{{i}}"></label>
            </div>
          </th>
          <td width="12%" class="cursor-pointer text-center pl-0" [routerLink]="['/admin/detail']"
            (click)="navigateToDetailPage(admin)">
            <!-- <img class="home-grid-image" src="{{admin.avatar}}" alt="{{admin.name}}" /> -->
            <img *ngIf="admin.image" class="home-grid-image" src="{{admin.image}}" alt="{{admin.name}}" />
            <img *ngIf="!admin.image" class="home-grid-image" src="assets/images/user_male.png" alt="{{admin.name}}" />
            <!-- <i class="fa fa-window-minimize" style="font-size: 1.1rem; line-height: 0px; color: red;"></i> -->
            <br>
            <!-- <i class="fa fa-window-minimize" style="line-height: 0px; color: green;"></i> -->
            <i *ngIf="admin.status=='ACTIVE'" class="fa fa-window-minimize" style="line-height: 0px; color: green;"></i>
            <i *ngIf="admin.status=='INVITED'" class="fa fa-window-minimize"
              style="line-height: 0px; color: rgb(240, 173, 68);"></i>
            <i *ngIf="admin.status=='DISABLED' || admin.status=='INACTIVE'" class="fa fa-window-minimize"
              style="line-height: 0px; color: red"></i>
          </td>

          <td width="16%" class="cursor-pointer d-table-cell d-sm-none" [routerLink]="['/admin/detail']"
            (click)="navigateToDetailPage(admin)">
            <b>{{admin.name}}</b><br>
            <span class="mt-2">{{admin.username}}</span><br>
            <span class="mt-2">{{admin.isd}}{{admin.phone}}</span>
          </td>
          <td class="cursor-pointer d-none d-sm-table-cell" [routerLink]="['/admin/detail']"
            (click)="navigateToDetailPage(admin)">{{admin.name}}</td>
          <td width="21%" class="cursor-pointer d-none d-sm-table-cell" [routerLink]="['/admin/detail']"
            (click)="navigateToDetailPage(admin)">{{admin.username}}</td>
          <td width="16%" class="cursor-pointer d-none d-sm-table-cell" [routerLink]="['/admin/detail']"
            (click)="navigateToDetailPage(admin)">{{admin.isd}}{{admin.phone}}</td>
          <td width="13%" class="cursor-pointer">
            <div *ngFor="let role of admin.roles" [routerLink]="['/admin/detail']"
              (click)="navigateToDetailPage(admin)">{{role | role_display}}</div>
          </td>
          <td width="12%" class="cursor-pointer d-none d-sm-table-cell" (click)="navigateToDetailPage(admin)" [routerLink]="['/admin/detail']">
            {{admin.lastSignedIn | timeAgo}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Modal Add User Info -->
<div class="modal fade" id="addAdmin" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="addAdminTitle">Invite User</h5>
        <button id="closeInviteAdmin" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" (click)="resetAddAdminForm()">&times;</span>
        </button>
      </div>
      <form name="adminInfo" #addAdminForm="ngForm" novalidate (ngSubmit)="onCreateAdmin(addAdminForm)">
        <div class="modal-body">
          <div class="row hide-x-scroll">
            <!-- <div class="col-lg-3 col-md-3 col-sm-3 col-4">
              <input class="hide" #adminPhoto name="adminPhoto" type="file" />
              <button class="btn btn-light rounded-circle upload-img-btn" (click)="adminPhoto.click()">Add
                Image</button>
            </div> -->
            <div class="col-lg-2 col-md-2 col-sm-3 col-3 pr-0 text-center">
              <div *ngIf="!adminFormData.image">
                <img src="assets/images/person.jpg" class="img-thumbnail full-img">
              </div>
              <div *ngIf="adminFormData.image">
                <img [src]="adminFormData.image" class="img-thumbnail full-img">
              </div>
              <div style="height:0px;overflow:hidden">
                <input #uploadUserLogo id="uploadUserLogoInput" name="uploadUserLogoInput" type="file"
                  (click)="uploadUserLogo.value=null" (change)="uploadFleetB2BLogo($event)" accept=".jpg,.png,.jpeg">
              </div>
              <small><a style="cursor:pointer" (click)="changeuploadFleetB2BLogoClicked()"><u>Upload
                    Image</u></a></small>
            </div>
            <div class="col-lg-10 col-md-10 col-sm-9 col-9">
              <div class="form-group">
                <label for="adminName"><span class="maroon  astrisk">&#10033;&nbsp;</span>Name</label>
                <input type="text" class="form-control" id="adminName" name="adminName" placeholder="Name" required
                  [(ngModel)]="adminFormData.name" #adminName="ngModel">
                <small class="text-danger text-center" *ngIf="adminName.errors && addAdminForm.submitted">
                  <p class="mb-0" *ngIf="adminName.errors.required">*Required</p>
                </small>
              </div>
              <div class="form-group">
                <label for="adminEmail"><span class="maroon  astrisk">&#10033;&nbsp;</span>Email</label>
                <input type="email" class="form-control" id="adminEmail" name="adminEmail" placeholder="Email Address"
                  required [(ngModel)]="adminFormData.adminEmail" #adminEmail="ngModel" pattern="^[^@]+@[^@]+\.[^@]+$">
                <small class="text-danger text-center" *ngIf="adminEmail.errors && addAdminForm.submitted">
                  <p class="mb-0" *ngIf="adminEmail.errors.required">*Required</p>
                  <p class="mb-0" *ngIf="!adminEmail.errors.required">Invalid email</p>
                </small>
              </div>
              <!-- <div class="form-group">
                <label for="adminPhone"><span class="maroon  astrisk">&#10033;&nbsp;</span><span>Phone</span></label>
                <div class="">
                  <ngx-intl-tel-input
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [separateDialCode]="true"
                    [selectFirstCountry]="false"
                    [searchCountryPlaceholder]="'Search Country'"
                    [preferredCountries]="preferredCountries"
                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name, SearchCountryField.DialCode]" 
                    [numberFormat]="PhoneNumberFormat.National"
                    [selectedCountryISO]="selectedCountryISO"
                    (countryChange)="onCountryChange($event)"
                    [(ngModel)]="selectedPhone" 
                    name="countryCode"
                    #countryCode="ngModel"
                    required
                  >
                  </ngx-intl-tel-input>
                  <small class="text-danger text-center" *ngIf="countryCode.errors && addAdminForm.submitted">
                    <p class="mb-0" *ngIf="countryCode.errors.required">*Required</p>
                    <p class="mb-0" *ngIf="!countryCode.errors.required">Invalid Phone</p>
                  </small>
                </div>
              </div> -->

              <!-- <div class="form-group">
                <label><span class="maroon astrisk">&#10033;&nbsp;</span>Country</label>
                <select id="countrySelect" class="w-100" aria-placeholder="Select Country" [(ngModel)]="adminFormData.country"
                (change)="onCountrySelected($event.target.value)" name="country" #country="ngModel" required>
                  <option [ngValue]=null>Select Country</option>
                  <option *ngFor="let country of countryList" value={{country.name}}>{{country.name}}</option>
                </select>
                <small class="text-danger text-center" *ngIf="country.errors && addAdminForm.submitted">
                  <p class="mb-0" *ngIf="country.errors.required">*Required</p>
                </small>
              </div> -->
              <!-- <div class="form-group">
                <label for="adminPhone"><span class="maroon  astrisk">&#10033;&nbsp;</span>Phone</label>
                <div class="row">
                  <div class="form-group col-4 pr-1">
                    <ng-template #rt_isd let-r="result" let-t="term">
                      <ngb-highlight [result]="r.name + ' ' + r.isd" [term]="t"></ngb-highlight>
                    </ng-template>
                    <input id="typeahead-isd-template" type="text" class="form-control" name="isd" #isd="ngModel" placeholder="ISD..."
                      [(ngModel)]="selectedIsdDetails" [ngbTypeahead]="searchIsd" [resultTemplate]="rt_isd"
                      [inputFormatter]="isdFormatter" [editable]='false' (selectItem)="onIsdSelected($event.item)" required disabled>
                    <small class="text-danger text-center" *ngIf="isd.errors && addAdminForm.submitted">
                      <p class="mb-0" *ngIf="isd.errors.required">*Required</p>
                    </small>
                  </div>
                  <div class="col-8 pl-1">
                    <input type="text" class="form-control" id="adminPhone" [pattern]="'[0-9]{' + phoneLength + '}'"
                      [placeholder]="'X'.repeat(phoneLength)" [maxlength]="phoneLength" name="adminPhone"
                      [(ngModel)]="adminFormData.adminPhone" #adminPhone="ngModel"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
                    <small class="text-danger text-center" *ngIf="adminPhone.errors && addAdminForm.submitted">
                      <p class="mb-0" *ngIf="adminPhone.errors.required">*Required</p>
                      <p class="mb-0" *ngIf="!adminPhone.errors.required">Invalid Phone</p>
                    </small>
                  </div>
                </div>
              </div> -->

              <!-- <div>
                <label for="countryIsd"><span class="maroon astrisk">&#10033;&nbsp;</span>Phone</label>
                <div class="form-group d-flex">
                  <select id="countryIsd" [(ngModel)]="selectedCountryIsd" name="countryIsd" #countryIsd="ngModel"
                    class="form-control" style="max-width: 173px; box-shadow: none">
                    <option [value]="null">Select ISD</option>
                    <option *ngFor="let country of countries" [value]="country.dialCode">{{country.label}}</option>
                  </select>

                  <input type="text" class="form-control" id="userPhone" name="userPhone" placeholder="Enter Phone"
                    maxlength="12" [(ngModel)]="selectedUserPhone" #userPhone="ngModel" oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
                </div>

                <small class="text-danger text-center" *ngIf="userPhone.errors && addAdminForm.submitted">
                  <p class="mb-0" *ngIf="userPhone.errors.required">*Required</p>
                </small>
              </div> -->

              <div>
                <label for="countryIsd"><span class="maroon astrisk">&#10033;&nbsp;</span>Phone</label>
                <div class="form-group d-flex custom-select-wrapper">
                  <select [(ngModel)]="adminCountryIsotwo" name="country" (ngModelChange)="countryUpdated($event)">
                    <option *ngFor="let c of allCountryList" [value]="c.isotwo">{{c.isd}} {{c.name}}</option>
                  </select>
                  <span class="selected-isd" *ngIf="adminCountryIsotwo">{{getadminCountryIsotwoIsd()}}</span>

                  <input placeholder="Phone Number" type="text" class="form-control" id="phoneElement" name="phoneElement"
                    #phoneElement="ngModel" appPhoneValidator appPhoneFormatter [(ngModel)]="adminPhone" required />
                </div>

                <small class="text-danger text-center" *ngIf="phoneElement?.errors && addAdminForm.submitted">
                  <p class="mb-0" *ngIf="phoneElement.errors?.required">*Required</p>
                  <p class="mb-0" *ngIf="phoneElement.errors?.invalidPhone">Invalid Phone</p>
                </small>
              </div>

              <div class="form-group">
                <label for="role"><span class="maroon astrisk">&#10033;&nbsp;</span>Select Role</label>
                <select id="model" class="w-100" id="role" aria-placeholder="Select Role"
                  [(ngModel)]="adminFormData.role" name="role" #role="ngModel">
                  <option *ngFor="let role of userRoles" [value]="role">{{role | role_display}}</option>
                  <!-- <option value="ROLE_ACCOUNT_ADMIN">Account Admin</option>
                  <option value="ROLE_ACCOUNT_DEVELOPER">Developer</option>
                  <option value="ROLE_ACCOUNT_FINANCE_USER">Finance User</option> -->
                  <!-- <option value="ROLE_FLEET_OPERATOR">Fleet Operator</option>
                  <option value="ROLE_RENTER">Renter</option> -->
                  <!-- <option value="ROLE_FMC_DRIVER">Driver</option> -->
                </select>
              </div>
              <!-- <div class="form-group">
                <label><span class="maroon astrisk">&#10033;&nbsp;</span>Select Role</label>
                <select id="model" class="w-100" aria-placeholder="Select Role" [(ngModel)]="adminFormData.role"
                  name="role" (change)="roleSelected($event)" #role="ngModel"> 
                  <option *ngFor= "let role of userRoles" value={{role}}>{{role | role_display}}</option>
                </select>
              </div> -->
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetAddAdminForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">SAVE</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Confirmation Model -->
<div class="modal fade" id="deleteAdmin" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="deleteAdminTitle">Delete User(s)</h5>
        <button type="button" class="close" (click)="cancelDeleteUser()" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div class="align-self-center text-center">Confirm deleting selected user(s) ?</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" (click)="cancelDeleteUser()" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" data-dismiss="modal" (click)="onDeleteAdmins()">OK</button>
      </div>
    </div>
  </div>
</div>